import administracion from "./administracion/administracion"
import citas from "./citas/citas"
import recepcion from "./recepcion/recepcion"
import estadisticas from "./estadisticas/estadisticas"

const siccij = {
    administracion:administracion,
    citas: citas,
    recepcion:recepcion,
    estadisticas: estadisticas
}

export default siccij


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICCIJ/sistema/siccij.js
// module id = null
// module chunks = 